(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/draw-analysis.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/draw-analysis.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const EmptyNotice = svs.component.tipsenEmptyNotice.EmptyNotice;
const _svs$component$analyz = svs.component.analyze,
  AuthorProfile = _svs$component$analyz.AuthorProfile,
  EventAnalyses = _svs$component$analyz.EventAnalyses,
  TransferAnalyses = _svs$component$analyz.TransferAnalyses;
const selectMatchAnalyses = svs.components.sportinfo.gameAnalysesRedux.selectors.selectMatchAnalyses;
const useDrawAnalyses = svs.components.sportinfo.gameAnalysesRedux.hooks.useDrawAnalyses;
const getDisplayName = svs.utils.products.getDisplayName;
const EMPTY_ARRAY = [];
const useGroupedAnalyses = drawAnalyses => {
  var _useMemo;
  const matchAnalyses = useSelector(selectMatchAnalyses);
  const matchAnalysesForDrawAnalyses = useMemo(() => drawAnalyses.map(_ref => {
    let gameAnalysesIds = _ref.gameAnalysesIds;
    return gameAnalysesIds.map(matchAnalysisId => matchAnalyses[matchAnalysisId]);
  }), [drawAnalyses, matchAnalyses]);
  const analysesGroupedOnEvent = (_useMemo = useMemo(() => {
    if (drawAnalyses.length > 0) {
      const analysesByEvent = new Array(drawAnalyses[0].gameAnalysesIds.length).fill(null).map(() => []);
      for (const matchAnalysis of matchAnalysesForDrawAnalyses.flat()) {
        analysesByEvent[matchAnalysis.eventNumber - 1].push(matchAnalysis);
      }
      return analysesByEvent;
    }
  }, [drawAnalyses, matchAnalysesForDrawAnalyses])) !== null && _useMemo !== void 0 ? _useMemo : EMPTY_ARRAY;
  return analysesGroupedOnEvent;
};
const useExpandableAnalyses = matchAnalyses => {
  const getNewExpanded = useCallback(() => {
    const expanded = {};
    for (const analyses of matchAnalyses) {
      const matchId = analyses[0].gameInfo.sportEvents[0];
      expanded[matchId] = false;
    }
    return expanded;
  }, [matchAnalyses]);
  const _useState = useState(() => getNewExpanded()),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  useEffect(() => {
    const expanded = getNewExpanded();
    setExpanded(expanded);
  }, [getNewExpanded]);
  const toggleExpandedState = useCallback(matchId => {
    setExpanded(current => _objectSpread(_objectSpread({}, current), {}, {
      [matchId]: !current[matchId]
    }));
  }, []);
  return {
    expanded,
    toggleExpandedState
  };
};
const updateAuthors = drawAnalyses => () => drawAnalyses.map((_ref2, index) => {
  let authorId = _ref2.authorId;
  return {
    authorId,
    selected: index === 0
  };
});
const DrawAnalyses = _ref3 => {
  let branding = _ref3.branding,
    drawId = _ref3.drawId,
    setCoupon = _ref3.setCoupon,
    eventTypeId = _ref3.eventTypeId,
    sportType = _ref3.sportType,
    drawNumber = _ref3.drawNumber,
    productId = _ref3.productId;
  const drawAnalyses = useDrawAnalyses(drawId);
  const analysesByEvent = useGroupedAnalyses(drawAnalyses);
  const _useExpandableAnalyse = useExpandableAnalyses(analysesByEvent),
    expanded = _useExpandableAnalyse.expanded,
    toggleExpandedState = _useExpandableAnalyse.toggleExpandedState;
  const _useState3 = useState(updateAuthors(drawAnalyses)),
    _useState4 = _slicedToArray(_useState3, 2),
    authors = _useState4[0],
    setAuthors = _useState4[1];
  useEffect(() => {
    setAuthors(updateAuthors(drawAnalyses));
  }, [drawAnalyses]);
  if (drawAnalyses.length === 0 || authors.length === 0) {
    return React.createElement(EmptyNotice, {
      branding: branding
    }, "F\xF6r tillf\xE4llet har vi ingen spelanalys");
  }
  const handleToggleAuthor = index => {
    setAuthors(current => {
      const copy = current.slice(0);
      copy[index] = _objectSpread(_objectSpread({}, copy[index]), {}, {
        selected: !copy[index].selected
      });
      return copy;
    });
  };
  const title = drawAnalyses[0].title || getDisplayName(productId);
  return React.createElement("div", {
    className: "route-play-draw-analyses"
  }, React.createElement("div", {
    className: "f-content"
  }, React.createElement("h2", null, title), React.createElement("div", {
    className: "margin-bottom-2",
    dangerouslySetInnerHTML: {
      __html: drawAnalyses[0].ingress
    }
  }), React.createElement("h3", {
    className: "f-550"
  }, "Kort om alla matcher")), React.createElement("div", {
    className: "margin-bottom-2"
  }, authors.map((_ref4, index) => {
    let authorId = _ref4.authorId,
      selected = _ref4.selected;
    return React.createElement(AuthorProfile, {
      authorId: authorId,
      key: authorId,
      noLabel: true,
      onToggle: () => {
        handleToggleAuthor(index);
      },
      selected: selected
    });
  })), React.createElement("ul", {
    className: "draw-analysis-analyses"
  }, analysesByEvent.map(matchAnalyses => {
    const matchId = matchAnalyses[0].gameInfo.sportEvents[0];
    return React.createElement(EventAnalyses, {
      analyses: matchAnalyses,
      authors: authors,
      branding: branding,
      drawNumber: drawNumber,
      eventTypeId: eventTypeId,
      isExpanded: expanded[matchId],
      key: matchAnalyses[0].id,
      onToggleExpand: toggleExpandedState,
      productId: productId,
      sportType: sportType
    });
  })), React.createElement(TransferAnalyses, {
    drawId: drawId,
    eventTypeId: eventTypeId,
    setCoupon: setCoupon,
    sportType: sportType
  }), React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: drawAnalyses[0].body
    }
  }));
};
setGlobal('svs.component.analyze.DrawAnalyses', DrawAnalyses);

 })(window);